var search = function search() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$products = _ref.products,
    products = _ref$products === void 0 ? [] : _ref$products,
    pageName = _ref.pageName,
    userId = _ref.customer_id,
    term = _ref.term,
    offset = _ref.offset,
    attributionToken = _ref.attributionToken;
  if (pageName === 'busca' && (products == null ? void 0 : products.length)) {
    var productDetails = products.map(function (product) {
      return {
        product: {
          id: product.variationId
        }
      };
    });
    return {
      cloud_retail: {
        attributionToken: attributionToken,
        eventType: 'search',
        offset: offset,
        productDetails: productDetails,
        searchQuery: term,
        userInfo: {
          userId: userId
        }
      },
      event: 'cloud_retail'
    };
  }
  return null;
};
export default search;